<dx-chart [dataSource]="dataSource"
          (onPointClick)="onPointClick($event)"
          (onDone)="contentReady.emit(true)">
    <dxo-chart-size [width]="width"></dxo-chart-size>
    <dxi-chart-series valueField="targetValue"
                      name="Milestone"
                      color="var(--adapt-milestone-color)"></dxi-chart-series>
    <dxi-chart-series valueField="recordedValue"
                      name="Measurement"
                      color="var(--adapt-measurement-color)">
        <dxo-chart-point symbol="triangle"></dxo-chart-point>
    </dxi-chart-series>
    <dxo-chart-common-series-settings type="line"
                                      argumentField="timestamp"></dxo-chart-common-series-settings>
    <dxo-chart-argument-axis discreteAxisDivisionMode="crossLabels"
                             [valueMarginsEnabled]="true">
        <dxo-chart-label [visible]="true"
                         format="MM/yyyy"></dxo-chart-label>
        <dxo-chart-grid [visible]="true"></dxo-chart-grid>
    </dxo-chart-argument-axis>
    @if (goal?.unit) {
        <dxi-chart-value-axis>
            <dxo-chart-title [text]="goal.unit"></dxo-chart-title>
        </dxi-chart-value-axis>
    }
    <dxo-chart-tooltip [enabled]="true"
                       [customizeTooltip]="customiseTooltip"> </dxo-chart-tooltip>
    <dxo-chart-legend [visible]="hasRecordedValue"
                      verticalAlignment="top"
                      horizontalAlignment="center"
                      itemTextPosition="right"></dxo-chart-legend>
</dx-chart>
